import { Table, TableBody, TableHead, TableRow, TD, TH } from '../../components/shared/Table';
import { Text } from '../../components/shared/Text';
import { Checkbox } from '../../components/shared/Checkbox';
import { ReactNode } from 'react';
import { API_EndpointResult } from '../../scripts/api/api_v2_def';
import { useSingleSelectionStore } from '../../store/useSingleSelectionStore';
import { CardProfile } from '../../types/CardProfile';

const orderColumnArray = [
	{ id: 'checkbox_1', width: '40px', header: '' },
	{ id: 'cardId', width: 'minmax(150px, 1fr)', header: 'Card ID' },
	{ id: 'email', width: 'minmax(150px, 1fr)', header: 'Account' },
	{ id: 'checkbox_2', width: '150px', header: '', headerStyle: undefined },
];

const orderColumns = orderColumnArray.map((c) => c.width).join(' ');

export function CardProfileTable({ cards }: { cards: API_EndpointResult<'card.list'> | undefined }) {
	return (
		<Table>
			<TableHead columns={orderColumns}>
				{orderColumnArray.map((c) => (
					<TH style={c.headerStyle ? c.headerStyle : undefined}>{c.header}</TH>
				))}
			</TableHead>
			<TableBody>
				{cards?.cards?.map((card) => {
					return <CardProfileRow card={card} key={card.id} />;
				})}
			</TableBody>
		</Table>
	);
}

function CardProfileRow({ card }: { card: CardProfile }) {
	const { toggleSelection, selection } = useSingleSelectionStore();

	const cellContent: Record<string, ReactNode> = {
		checkbox_1: <Checkbox onChange={() => toggleSelection(card.id)} value={selection[card.id]} />,
		cardId: (
			<Text $color="text_desc_main" $size="1.3rem" $weight="400">
				{card.cardId}
			</Text>
		),
		email: (
			<Text $color="text_desc_main" $size="1.3rem" $weight="400">
				{card.emails.map((email) => (
					<>
						{email}
						<br />
					</>
				))}
			</Text>
		),

		checkbox_2: <Checkbox onChange={() => toggleSelection(card.id)} value={selection[card.id]} />,
	};

	return (
		<TableRow $columns={orderColumns} key={card.id} $highlighted={selection[card.id]} $hoverEnabled={true}>
			{orderColumnArray.map((c) => (
				<TD style={c.headerStyle ? c.headerStyle : undefined}>{cellContent[c.id]}</TD>
			))}
		</TableRow>
	);
}
